// Captura UTMs y referrer en sessionStorage en el primer load
const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
];

export function captureUtmParams() {
    try {
        const url = new URL(window.location.href);
        const stored = JSON.parse(
            sessionStorage.getItem("eclipse_utm") || "{}",
        );
        const next = { ...stored };
        let touched = false;

        UTM_KEYS.forEach((k) => {
            const v = url.searchParams.get(k);
            if (v && !next[k]) {
                next[k] = v;
                touched = true;
            }
        });

        if (!next.referrer && document.referrer) {
            next.referrer = document.referrer;
            touched = true;
        }
        if (!next.landing_page) {
            next.landing_page =
                window.location.pathname + window.location.search;
            touched = true;
        }

        if (touched) {
            sessionStorage.setItem("eclipse_utm", JSON.stringify(next));
        }
    } catch (e) {
        // silently fail — UTM tracking is best-effort
    }
}

export function getUtmParams() {
    try {
        return JSON.parse(sessionStorage.getItem("eclipse_utm") || "{}");
    } catch {
        return {};
    }
}
